import React, { useEffect, useState } from "react";
import {
    PDFViewer,
    Document,
    Page,
    Text,
    View,
    Image,
    StyleSheet
} from "@react-pdf/renderer";
import { useHistory, useLocation } from "react-router-dom";
import { useStore } from "../../shared/hooks/stateStore";
import { routeConfig } from "../../shared/common/constant";
import { Skeleton } from "antd";
import header from '../../assets/header.png';
import { fixedDecimal } from "../../shared/hooks/utils";

const BORDER_COLOR = '#5E5E5E'
const KEY_FONT_COLOR = '#5E5E5E'
const TABLE_HEADER_COLOR = '#D5D5D5'
const WHITE = '#FFFFFF'
const BLACK = '#000000'
const BORDER_STYLE = 'solid'
const BORDER_WIDTH = 1.3
const styles = StyleSheet.create({
    body: {
        paddingLeft: 7,
        paddingRight: 7,
        paddingTop: 7
    },
    table: {
        display: "table",
        width: "auto",
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        borderRightWidth: 0,
        borderBottomWidth: 0
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row"
    },
    tableRowHeight60: {
        margin: "auto",
        flexDirection: "row",
        height: 60
    },
    tableCol: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderBottomColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 1
    },
    tableColNoRight: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        // borderBottomColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        borderRightWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 2
    },
    tableColNoBottom: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        // borderBottomColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        borderBottomWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 2
    },
    tableColNoBorder: {
        borderRightWidth: 0,
        borderBottomWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 2
    },
    tableColNoPadding: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderBottomColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        paddingTop: 1
    },
    tableCellHeader: {
        margin: "auto",
        //   margin: 5, 
        fontSize: 12,
        fontWeight: 500
    },
    tableCell: {
        // margin: "auto",
        // marginLeft: 5,
        fontSize: 9,
        fontWeight: "black"
    },
    tableCellSmall: {
        // margin: "auto",
        //   margin: 5, 
        fontSize: 8
    },
    height10: {
        height: 10
    },
    height20: {
        height: 20
    },
    height235: {
        height: 23.5
    },
    height255: {
        height: 25.5
    },
    height25: {
        height: 25
    },
    height27: {
        height: 27
    },
    height30: {
        height: 30
    },
    height35: {
        height: 35
    },
    height38: {
        height: 38
    },
    height40: {
        height: 40
    },
    height60: {
        height: 60
    },
    height80: {
        height: 80
    },
    height90: {
        height: 90
    },
    width5: {
        width: "5%"
    },
    width6: {
        width: "6%"
    },
    width7: {
        width: "7%"
    },
    width8: {
        width: "8%"
    },
    width9: {
        width: "9%"
    },
    width10: {
        width: "10%"
    },
    width125: {
        width: "12.5%"
    },
    width13: {
        width: "13%"
    },
    width15: {
        width: "15%"
    },
    width20: {
        width: "20%"
    },
    width22: {
        width: "22%"
    },
    width25: {
        width: "25%"
    },
    width40: {
        width: "40%"
    },
    width43: {
        width: "43%"
    },
    width50: {
        width: "50%"
    },
    width52: {
        width: "52%"
    },
    width75: {
        width: "75%"
    },
    width85: {
        width: "85%"
    },
    width100: {
        width: "100%",
    },
    footerPadding: {
        paddingTop: 12,
        paddingBottom: 5,
        letterSpacing: 4,
        color: KEY_FONT_COLOR
    },
    padding2: {
        padding: 2
    },
    padding4: {
        padding: 4
    },
    paddingTop7: {
        paddingTop: 7
    },
    marginBottom4: {
        marginBottom: 4
    },
    marginBottom8: {
        marginBottom: 8
    },
    marginTopBtm5: {
        marginBottom: 5,
        marginTop: 5
    },
    marginTop3: {
        marginTop: 3
    },
    marginTop5: {
        marginTop: 5
    },
    marginTop8: {
        marginTop: 8
    },
    marginTop10: {
        marginTop: 10
    },
    marginTop30: {
        marginTop: 30
    },
    fontSize8: {
        fontSize: 8
    },
    fontSize10: {
        fontSize: 10
    },
    fontSize12: {
        fontSize: 12
    },
    textCenter: {
        textAlign: "center"
    },
    textRight: {
        textAlign: "right"
    },
    backgroundText: {
        backgroundColor: '#EBEBEB',
        padding: 5,
        borderRadius: 3
    },
    tableHeader: {
        backgroundColor: TABLE_HEADER_COLOR
    },
    tableCellKey: {
        color: KEY_FONT_COLOR
    },
    backgroundBlack: {
        backgroundColor: BLACK,
        color: WHITE,
    },
    tableColZeroPadding: {
        borderStyle: BORDER_STYLE,
        borderColor: BORDER_COLOR,
        borderBottomColor: BORDER_COLOR,
        borderWidth: BORDER_WIDTH,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 0
    },
    margin3: {
        marginTop: 3,
        marginBottom: 3
    },
    image: {
        height: '13%',
        width: '100%',
        backgroundColor: '#ffffff'
    }
});

let packingListStoreData;
let packingListId;
let isPallet = true;
const PackingListPdf = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [showManufactureDetailConst, setShowManufactureDetailConst] = useState<boolean>(true);
    const history = useHistory();
    const location = useLocation();
    useEffect(() => {
        packingListStoreData = useStore.getState().packingList;
        const manufactureDetailData = useStore.getState().manufactureDetailData;
        if (manufactureDetailData && manufactureDetailData.length) {
            onChangeManufacture(packingListStoreData.manufactureDetails, manufactureDetailData);
        }
        if (location.pathname.split('/').length === 3) {
            packingListId = location.pathname.split('/')[2];
            if (!packingListStoreData) {
                history.push(routeConfig.allPackingList.path)
            } else {
                isPallet = !packingListStoreData.packingListItemDetails.some((eachPackingItems) => eachPackingItems.noOfPallets && eachPackingItems.weightOfPallet);
                setLoading(false);
            }
        }
    }, [])
    const onChangeManufacture = (manufactureDetailsId, manufactureDetailData) => {
        const manuFactureIndex = manufactureDetailData.findIndex((eachPOInvoice) => eachPOInvoice['_id'] === manufactureDetailsId);
        if (manuFactureIndex != undefined && manuFactureIndex !== -1) {
            const manufactureDetail = manufactureDetailData[manuFactureIndex].businessPartnerId;
            packingListStoreData.manuFactureDetailsConst = {
                name: manufactureDetail.name,
                address: manufactureDetail.address,
                phoneNumber: manufactureDetail.phoneNumber,
                email: manufactureDetail.email
            };
        } else {
            setShowManufactureDetailConst(false);
        }
    }
    return (
        <>
            {
                loading ? <Skeleton active /> :
                    <PDFViewer style={{ height: '100%', width: '100%' }} >
                        <MyDocument packingListStoreData={packingListStoreData} isPallet={isPallet} showManufactureDetailConst={showManufactureDetailConst} />
                    </PDFViewer>
            }
        </>
    );
}

export default PackingListPdf

const MyDocument = ({ packingListStoreData, isPallet, showManufactureDetailConst }) => (
    <Document title="Packing List" >
        <Page size="A4">
            <Image src={header} style={[styles.image]} />
            <View style={[styles.backgroundBlack, styles.marginTop5, styles.padding4, styles.marginBottom4]}>
                <Text style={[styles.fontSize12, , styles.textCenter]}>PACKING LIST</Text>
            </View>
            <View style={styles.body}>
                <View style={[styles.table]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}> Invoice No</Text>
                            <Text style={[styles.tableCell]}>{packingListStoreData.invoiceNumber}</Text>
                        </View>

                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Invoice Date</Text>
                            <Text style={[styles.tableCell]}>{packingListStoreData.date}</Text>
                        </View>

                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Exporter Ref No.</Text>
                            <Text style={[styles.tableCell]}>{packingListStoreData.exporterRefNo.invoiceNumber}</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Customer PO No.</Text>
                            <Text style={[styles.tableCell]}>{packingListStoreData.customerPoNumber}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width50, styles.height90]}>
                            <Text style={[styles.tableCell, styles.tableCellKey]}>Consignee</Text>
                            <Text style={styles.tableCell}>{packingListStoreData.businessPartnerId.name}</Text>
                            <Text style={styles.tableCellSmall}>{packingListStoreData.businessPartnerId.address} </Text>
                            {/* <Text style={styles.tableCellSmall}>{packingListStoreData.businessPartnerId.phoneNumber}</Text>
                            <Text style={styles.tableCellSmall}>{packingListStoreData.businessPartnerId.email}</Text> */}
                        </View>
                        <View style={[styles.tableCol, styles.width50, styles.height90]}>
                                <Text style={[styles.tableCell, styles.tableCellKey]}>Buyer</Text>
                                <Text style={styles.tableCell}>{packingListStoreData.buyer.name}</Text>
                                <Text style={styles.tableCellSmall}>{packingListStoreData.buyer.address} </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Method of Dispatch</Text>
                            <Text style={styles.tableCell}>{packingListStoreData.methodOfDispatch.shippingMode} </Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Vessel/Flight No</Text>
                            <Text style={styles.tableCell}>{packingListStoreData.vesselNo} </Text>
                        </View>
                        {
                            packingListStoreData.finalDestination && (
                                <View style={[styles.tableCol, styles.width25]}>
                                    <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Final Destination</Text>
                                    <Text style={[styles.tableCell]}>{packingListStoreData.finalDestination.country} </Text>
                                </View>
                            )
                        }
                        <View style={[styles.tableCol, packingListStoreData.finalDestination ? styles.width25 : styles.width50]}>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Origin Country</Text>
                            <Text style={[styles.tableCell]}>{packingListStoreData.countryOfOrigin.country} </Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Destination Country </Text>
                            <Text style={styles.tableCell}>{packingListStoreData.countryOfDestination.country} </Text>
                        </View>
                        <View style={[styles.tableCol, styles.width50]}>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Port of Loading</Text>
                            <Text style={styles.tableCell}>{packingListStoreData.portOfLoading.port}, {packingListStoreData.portOfLoading.country} </Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Port of Destination</Text>
                            <Text style={styles.tableCell}>{packingListStoreData.portOfDischarge.port}, {packingListStoreData.portOfDischarge.country} </Text>
                        </View>
                        <View style={[styles.tableCol, styles.width50]}>
                        </View>
                    </View>
                    {isPallet && (<View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width25, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Description of Goods</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Packing Type</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Net Quantity (in Metric Ton)</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>No of Packages</Text>
                        </View>
                    </View>)}
                    {
                        isPallet && packingListStoreData.packingListItemDetails?.map((r, i) => {
                            return (
                                <View style={styles.tableRow} key={i}>
                                    <View style={[styles.tableCol, styles.width25, styles.textLeft]}>
                                        <Text style={styles.tableCell}>{r.descriptionOfGoods.productName}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.width25, styles.textLeft]}>
                                        <Text style={styles.tableCell}>{r.packingTypes.packingType}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.width25, styles.textRight]}>
                                        <Text style={styles.tableCell}>{fixedDecimal(r.quantity)}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.width25, styles.textRight]}>
                                        <Text style={styles.tableCell}>{fixedDecimal(r.noOfPackages)}</Text>
                                    </View>
                                </View>
                            )
                        })
                    }
                    {isPallet && (<View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width25, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Packages Type</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Net Weight (kgs)</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Tare Weight (Kgs)</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width25, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Total Gross Weight (Kgs)</Text>
                        </View>
                    </View>)}
                    {
                        isPallet && packingListStoreData.packingListItemDetails?.map((r, i) => {
                            return (
                                <View style={styles.tableRow} key={i}>
                                    <View style={[styles.tableCol, styles.width25, styles.textLeft]}>
                                        <Text style={styles.tableCell}>{r.unitType}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.width25, styles.textRight]}>
                                        <Text style={styles.tableCell}>{fixedDecimal(r.netWeight)}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.width25, styles.textRight]}>
                                        <Text style={styles.tableCell}>{fixedDecimal(r.tareWeight)}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.width25, styles.textRight]}>
                                        <Text style={styles.tableCell}>{fixedDecimal(r.totalGrossWeight)}</Text>
                                    </View>
                                </View>
                            )
                        })
                    }
                    {!isPallet && (<View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width20, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Description of Goods</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width20, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Packing Type</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width20, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Net Quantity (in Metric Ton)</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width20, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>No of Packages</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width20, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Packages Type</Text>
                        </View>
                    </View>)}
                    {
                        !isPallet && packingListStoreData.packingListItemDetails?.map((r, i) => {
                            return (
                                <View style={styles.tableRow} key={i}>
                                    <View style={[styles.tableCol, styles.width20, styles.textLeft]}>
                                        <Text style={styles.tableCell}>{r.descriptionOfGoods.productName}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.width20, styles.textLeft]}>
                                        <Text style={styles.tableCell}>{r.packingTypes.packingType}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.width20, styles.textRight]}>
                                        <Text style={styles.tableCell}>{fixedDecimal(r.quantity)}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.width20, styles.textRight]}>
                                        <Text style={styles.tableCell}>{fixedDecimal(r.noOfPackages)}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.width20, styles.textLeft]}>
                                        <Text style={styles.tableCell}>{r.unitType}</Text>
                                    </View>
                                </View>
                            )
                        })
                    }
                    {!isPallet && (<View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width20, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>No Of Pallets</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width20, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Weight Of Pallet</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width20, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Net Weight (kgs)</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width20, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Tare Weight (Kgs)</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width20, styles.textCenter, styles.tableHeader]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey, styles.margin3]}>Total Gross Weight (Kgs)</Text>
                        </View>
                    </View>)}
                    {
                        !isPallet && packingListStoreData.packingListItemDetails?.map((r, i) => {
                            return (
                                <View style={styles.tableRow} key={i}>
                                    <View style={[styles.tableCol, styles.width20, styles.textRight]}>
                                        <Text style={styles.tableCell}>{fixedDecimal(r.noOfPallets)}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.width20, styles.textRight]}>
                                        <Text style={styles.tableCell}>{fixedDecimal(r.weightOfPallet)}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.width20, styles.textRight]}>
                                        <Text style={styles.tableCell}>{fixedDecimal(r.netWeight)}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.width20, styles.textRight]}>
                                        <Text style={styles.tableCell}>{fixedDecimal(r.tareWeight)}</Text>
                                    </View>
                                    <View style={[styles.tableCol, styles.width20, styles.textRight]}>
                                        <Text style={styles.tableCell}>{fixedDecimal(r.totalGrossWeight)}</Text>
                                    </View>
                                </View>
                            )
                        })
                    }
                    <View style={[styles.tableRow, styles.height80]}>
                        <View style={[styles.tableCol, styles.width50]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Manufacture Details</Text>
                            {
                                !showManufactureDetailConst &&
                                <View>
                                    <Text style={styles.tableCell}>{packingListStoreData.manufactureDetails}</Text>
                                </View>
                            }
                            {
                                packingListStoreData.manuFactureDetailsConst && showManufactureDetailConst &&
                                <View>
                                    <Text style={styles.tableCell}>{packingListStoreData.manuFactureDetailsConst.name}</Text>
                                    <Text style={styles.tableCellSmall}>{packingListStoreData.manuFactureDetailsConst.address} </Text>
                                    <Text style={styles.tableCellSmall}>{packingListStoreData.manuFactureDetailsConst.phoneNumber}</Text>
                                    <Text style={styles.tableCellSmall}>{packingListStoreData.manuFactureDetailsConst.email}</Text>
                                </View>
                            }
                        </View>
                        <View style={[styles.tableColNoPadding, styles.width50]}>
                            <View style={[styles.tableRow, styles.height235]}>
                                <View style={[styles.tableColNoRight, styles.width50, styles.marginTop8, styles.textRight]}>
                                    {/* <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Net Weight Per Drum</Text> */}
                                </View>
                                <View style={[styles.tableColNoRight, styles.width50, styles.marginTop8]}>
                                    {/* <Text style={styles.tableCell}>11</Text> */}
                                </View>
                            </View>
                            <View style={[styles.tableRow, styles.height255]}>
                                <View style={[styles.tableColNoRight, styles.width50, styles.marginTop8, styles.textRight]}>
                                    <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Net Weight Per {packingListStoreData.packingListItemDetails[0].unitType} (Kgs)</Text>
                                </View>
                                <View style={[styles.tableColNoRight, styles.width50, styles.marginTop8, styles.textRight]}>
                                    <Text style={styles.tableCell}>{fixedDecimal(packingListStoreData.breakUpWeight.netWeightPerPackage)}</Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow, styles.height255]}>
                                <View style={[styles.tableColNoRight, styles.width50, styles.marginTop8, styles.textRight]}>
                                    <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Gross Weight Per {packingListStoreData.packingListItemDetails[0].unitType} (Kgs)</Text>
                                </View>
                                <View style={[styles.tableColNoRight, styles.width50, styles.marginTop8, styles.textRight]}>
                                    <Text style={styles.tableCell}>{fixedDecimal(packingListStoreData.breakUpWeight.grossWeightPerPackage)}</Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow, styles.height255]}>
                                <View style={[styles.tableColNoBorder, styles.width50, styles.marginTop8, styles.textRight]}>
                                    <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Tare Weight Per {packingListStoreData.packingListItemDetails[0].unitType} (Kgs)</Text>
                                </View>
                                <View style={[styles.tableColNoBorder, styles.width50, styles.marginTop8, styles.textRight]}>
                                    <Text style={styles.tableCell}>{fixedDecimal(packingListStoreData.breakUpWeight.tareWeightPerPackage)}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    {/* <View style={[styles.tableRow, styles.height38]}>
                        <View style={[styles.tableCol, styles.width100]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Note</Text>
                            <Text style={[styles.tableCellSmall, styles.marginTop10]}>{packingListStoreData.note}</Text>
                        </View>
                    </View> */}
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width15, styles.textRight]}>
                            <Text style={[styles.tableCell, styles.margin3, styles.fontSize8, styles.tableCellKey]}>Container No.</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width85]}>
                            <Text style={[styles.tableCell, styles.margin3]}>{packingListStoreData.containerNo}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, styles.width15, styles.textRight]}>
                            <Text style={[styles.tableCell, styles.margin3, styles.fontSize8, styles.tableCellKey]}>Seal No.</Text>
                        </View>
                        <View style={[styles.tableCol, styles.width85]}>
                            <Text style={[styles.tableCell, styles.margin3]}>{packingListStoreData.sealNo}</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, styles.height38]}>
                        <View style={[styles.tableCol, styles.width100]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Term & Condition</Text>
                            <Text style={[styles.tableCellSmall, styles.marginTop10]}>{packingListStoreData.termsAndConditions}</Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, styles.height60]}>
                        {/* <View style={[styles.tableCol, styles.width75]}>
                            <Text style={[styles.tableCell, styles.fontSize8, styles.tableCellKey]}>Declaration</Text>
                            <Text style={styles.tableCell}>{packingListStoreData.declaration} </Text>
                        </View> */}
                        <View style={[styles.tableColNoPadding, styles.width100]}>
                            <View style={[styles.tableRow, styles.height235]}>
                                <View style={[styles.tableColNoBorder, styles.width100, styles.textRight]}>
                                    <Text style={[styles.tableCell]}>For, Chemtrade</Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow, styles.height235]}>
                                <View style={[styles.tableColNoBorder, styles.width100, styles.marginTop8, styles.textRight]}>
                                    {/* <Text style={[styles.tableCell]}>For, Chemtrade</Text> */}
                                </View>
                            </View>
                            <View style={[styles.tableRow, styles.height235]}>
                                <View style={[styles.tableColNoBorder, styles.width100, styles.marginTop8, styles.textRight]}>
                                    <Text style={[styles.tableCell]}>Authorized Signature/Name</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
            </View>
            {/* footer */}
            <View style={[styles.footerPadding, styles.marginBottom4]}>
                <Text style={[styles.fontSize10, styles.textCenter]}>
                Industrial Chemicals | APIs
                        </Text>
            </View>
            <View style={[styles.backgroundBlack, styles.padding4]}>
                <Text style={[styles.fontSize10, styles.textCenter]}>
                    Plot No: 38, Kalathiya Corp. V-2, Diamond Nagar, Kholwad, Surat, Gujarat, India - 394180
                        </Text>
            </View>
        </Page>
    </Document >
);
